export default __webpack_public_path__ + "static/media/Cargo1.05b1c1a9.png";